import { createSelector } from 'reselect';
import { last, isEmpty } from 'underscore';
import {
  CAMERA_PRESENTER,
  IMAGE_FILE,
  VIDEO_FILE,
  AUDIO_FILE
} from '@shoflo/polymer/constants/SourceItems';
import { selectBroadcastSources } from '@shoflo/studio-redux/selectors/broadcastSourcesSelector';
import { orderSources } from 'actions/Broadcast/utils';

export const selectPresenterSources = createSelector(
  selectBroadcastSources,
  sources => sources.filter(s => s.type === CAMERA_PRESENTER)
);

export const selectLastPresenterSource = createSelector(
  selectPresenterSources,
  sources => {
    const lastCameraSource = last(orderSources(sources));

    return !isEmpty(lastCameraSource) ? lastCameraSource : {};
  }
);

export const selectMediaSources = createSelector(
  selectBroadcastSources,
  sources =>
    sources.filter(s => [IMAGE_FILE, VIDEO_FILE, AUDIO_FILE].includes(s.type))
);

export const selectLastMediaSource = createSelector(
  selectMediaSources,
  sources => {
    const lastMediaSource = last(orderSources(sources));

    return !isEmpty(lastMediaSource) ? lastMediaSource : {};
  }
);
